import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Grid, Tab } from "@mui/material";
import html2canvas from "html2canvas";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import "../../../assets/css/accountmetrics.scss";
import { ReactComponent as LeftIcon } from "../../../assets/icons/NewIcons/LeftIcon.svg";
import { ReactComponent as RightIcon } from "../../../assets/icons/NewIcons/RightIcon.svg";
import backBtn from "../../../assets/icons/UpdatedCheckoutPage/backBtn.svg";
import { dollarUS } from "../../../utilities/formatters";
import { formatDateInTimeZone, formatDateInTimeZoneUTC } from "../../../utilities/string";
import BalanceChart from "../../Charts/BalanceChart";
import ProfitChart from "../../Charts/ProfitChart";
import AMDropdown from "../../ReusableComponents/AMDropdown";
import HeadAndDesc from "../../ReusableComponents/HeadAndDesc";
import Title from "../../ReusableComponents/title";
import PnLChart from "../CalendarDetailData/PnLChart/PnLChart";
import TradeStats from "../CalendarDetailData/TradeStats/TradeStats";
import TradeTable from "../CalendarDetailData/TradeTable/TradeTable";
import NewCalender from "../NewCalender/NewCalender";

import Loader from "../../../reusableComponents/Loader";
import "./PublicShareDashboard.scss";

const StatFormatter = (data) => {
  const Stat = data && data.toLowerCase();

  const classList =
    Stat === "success"
      ? "StatusPassed"
      : Stat === "failed"
      ? "StatusFailed"
      : "StatusInProgress";

  return <div className={`AMStat statusIndicator ${classList}`}>{data}</div>;
};

const PublicShareDashboard = ({ ProfitHistory, data, loading }) => {
  const [value, setValue] = React.useState("1");
  const [selectedDateValue, setSelectedDateValue] = useState(false);
  const [dateWiseData, setDateWiseData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const ProfitData = ProfitHistory;
  const Trades = data?.accountMetrics?.data;

  const breachedAtString =
    (data?.accountObjectives?.drawdown_result?.breached_at &&
      data?.accountObjectives?.drawdown_result?.breached_at) ||
    ""; // Default to empty string if not defined

  let breachedAtObject = {};

  if (breachedAtString) {
    try {
      breachedAtObject = JSON.parse(breachedAtString);
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  console.log(data?.accountDetails, "data?.accountDetailsdata?.accountDetails");

  const targetDate =
    data?.accountObjectives &&
    data?.accountObjectives["drawdown_result"]["max_daily_loss"][
      "reset_utc_time"
    ];

  const handlePreviousDate = () => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() - 1); // Go one day back
      return newDate;
    });
  };

  const handleNextDate = () => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + 1); // Go one day forward
      return newDate;
    });
  };

  useEffect(() => {
    document.body.style.overflow = data.success === true ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [data.success]);

  // For filter the data according to selected date
  useEffect(() => {
    if (selectedDateValue) {
      window.scroll(0, 0);

      const utcDate = moment(selectedDate)?.format("DD-MM-YYYY");
      const tradeValues =
        Trades &&
        Trades?.filter((item) => formatDateInTimeZoneUTC(item?.date) === utcDate);
      setSelectedDateValue(tradeValues);
    }
  }, [selectedDate]);

  // Date Selector For Chart
  const currentDate = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(currentDate.getDate() - 30);

  // Ensure that both startDate and endDate are initialized as Date objects
  const [dateRange, setDateRange] = useState([tenDaysAgo, currentDate]);
  const [startDate, endDate] = dateRange;

  const formatDate = (date) => {
    if (!date) return "";
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(date).toLocaleDateString("en-GB", options); // Format as yyyy-MM-dd
  };
  // Function to convert UTC to local date format (for chart or other purposes)
  const utc_to_eet = (date) => {
    if (date) {
      const EETOffset = 0 * 60; // Adjust as needed for local timezone
      const localTime = new Date(
        new Date(date).getTime() + EETOffset * 60 * 1000
      ); // Ensure it's a valid date object
      return localTime.toISOString();
    }
    return "";
  };

  // Ensure valid Date objects and filter the data based on the selected date range
  const filteredData = useMemo(() => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      // Validate start and end dates
      if (
        !(start instanceof Date && end instanceof Date) ||
        isNaN(start.getTime()) ||
        isNaN(end.getTime())
      ) {
        console.error("Invalid date range provided");
        return [];
      }

      // Normalize dates to start and end of the day
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);

      // Filter data
      return Array.isArray(data?.performanceChart)
        ? data?.performanceChart.filter((item) => {
            const itemTime = new Date(item?.time);
            if (isNaN(itemTime.getTime())) {
              console.warn(
                `Invalid date in data?.performanceChart: ${item?.time}`
              );
              return false;
            }
            return itemTime >= start && itemTime <= end;
          })
        : [];
    }
    return [];
  }, [data?.performanceChart, startDate, endDate]);

  const legendData = [
    {
      title: "Balance",
      color: "#c7f464 ",
    },
    {
      title: "Equity",
      color: "#4ecdc4",
    },
    {
      title: "Profit target",

      color: "#64C144",
    },
    {
      title: "Max loss limit",

      color: "#FD504F",
    },
    {
      title: "Max daily loss",

      color: "#ff154498",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [currentTime, setCurrentTime] = useState(
    String(new Date()).split("GMT")[0].trim()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(String(new Date()).split("GMT")[0].trim());
    }, 5000); // Update time every 5 seconds

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <Loader open={loading} />;
  }

  const handleCapture = async () => {
    try {
      const elementsToExclude = [
        ...document.querySelectorAll(
          ".exclude, .intercom-lightweight-app, .weglot-container.wg-default"
        ),
      ];

      const elementsWithParents = elementsToExclude.map((element) => ({
        element,
        parent: element.parentNode,
        nextSibling: element.nextSibling,
      }));

      elementsToExclude.forEach((element) => {
        if (element) element.parentNode.removeChild(element);
      });

      const canvas = await html2canvas(document.body, { scale: 2 });

      elementsWithParents.forEach(({ element, parent, nextSibling }) => {
        if (nextSibling) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });

      const image = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = image;
      link.download = "screenshot.png";
      link.click();
    } catch (error) {
      console.error("Error capturing the screenshot:", error);
    }
  };

  return (
    <div className="publicShareDashboardContainer">
      {data?.success === true ? (
        <></>
      ) : (
        <div className="not_public_text">
          <h2>{"Account is not public"}</h2>
        </div>
      )}
      <div
        // className="programObjectivesContent"
        className={`programObjectivesContent ${
          data?.success ? "" : "not_Public"
        }`}
      >
        <div className="detailCalData_container">
          {selectedDateValue ? (
            <div className="detailCalData_wrapper">
              <div className="day_wise_data">
                <div className="headerSection">
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div className="dateBox">
                      <button onClick={handlePreviousDate}>
                        <LeftIcon />
                      </button>
                      <p>{moment(selectedDate).format("dddd, MMMM YYYY")}</p>
                      <button onClick={handleNextDate}>
                        <RightIcon />
                      </button>
                    </div>
                    <div
                      style={{ cursor: "pointer" }}
                      className="backBtnContainer"
                      onClick={() => setSelectedDateValue(false)}
                    >
                      <img
                        style={{ width: "20px" }}
                        src={backBtn}
                        alt="backBtn"
                      />
                      Back
                    </div>
                  </div>

                  {/* <div className="noteBtn">
                  <button>View Note</button>
                </div> */}
                </div>
                <div className="chartData">
                  <PnLChart selectedDateValue={selectedDateValue} />
                  <TradeStats selectedDateValue={selectedDateValue} />
                </div>
                <div className="tableData">
                  <TradeTable selectedDateValue={selectedDateValue} />
                </div>
              </div>

              <div className="statsTradeData">
                <Grid item md={5} xs={12} className="statisticsSection">
                  <Grid container className="StatisticsBox d-grid mbb-20">
                    <Grid className="mtt-20 AMStatBox">
                      <Grid
                        item
                        className="StatisticAM  mbb-20"
                        xs={6}
                        justifyContent="space-between"
                      >
                        <div className="firstBoxData">
                          <HeadAndDesc
                            className="hover-chart-text"
                            HeadTitle="Equity"
                            SubTitle={
                              data?.accountDetails &&
                              data?.accountDetails?.equity
                                ? dollarUS(data?.accountDetails?.equity)
                                : "$0"
                            }
                          />
                          <HeadAndDesc
                            className="hover-chart-text"
                            HeadTitle="Balance"
                            SubTitle={
                              data?.accountDetails &&
                              data?.accountDetails?.balance
                                ? dollarUS(data?.accountDetails?.balance)
                                : "$0"
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="No. of trades"
                            SubTitle={
                              (data?.accountMetrics?.calculated_data &&
                                data?.accountMetrics?.calculated_data
                                  ?.trades) ||
                              0
                            }
                          />{" "}
                          <HeadAndDesc
                            HeadTitle="Lots"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data?.lots
                                ? data?.accountMetrics?.calculated_data?.lots?.toFixed(
                                    2
                                  )
                                : 0
                            }
                          />
                        </div>

                        <div className="secondBoxData">
                          {" "}
                          <HeadAndDesc
                            HeadTitle="Win rate"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data?.win_ratio
                                ? `${data?.accountMetrics?.calculated_data?.win_ratio?.toFixed(
                                    2
                                  )} %`
                                : "$0"
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="Highest"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data?.highest
                                ? `${data?.accountMetrics?.calculated_data?.highest?.toFixed(
                                    2
                                  )}`
                                : "$0"
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="Average profit"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data
                                ?.average_profit
                                ? dollarUS(
                                    Number(
                                      data?.accountMetrics?.calculated_data
                                        ?.average_profit
                                    )?.toFixed(2)
                                  )
                                : "$0"
                            }
                            SubTitleClass="DescPositive"
                          />
                          <HeadAndDesc
                            HeadTitle="Average loss"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data
                                ?.average_loss
                                ? dollarUS(
                                    Number(
                                      data?.accountMetrics?.calculated_data
                                        ?.average_loss
                                    )?.toFixed(2)
                                  )
                                : "$0"
                            }
                            SubTitleClass="DescNegative"
                          />
                        </div>

                        <div className="thirdBoxData">
                          {" "}
                          <HeadAndDesc
                            HeadTitle="Average RRR"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data["rrr "]
                                ? Number(
                                    data?.accountMetrics?.calculated_data[
                                      "rrr "
                                    ]
                                  )?.toFixed(2)
                                : 0
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="Expectancy"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data?.expectancy
                                ? data?.accountMetrics?.calculated_data?.expectancy?.toFixed(
                                    2
                                  )
                                : 0
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="Profit Factor"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data
                                ?.profit_factor
                                ? data?.accountMetrics?.calculated_data?.profit_factor?.toFixed(
                                    2
                                  )
                                : 0
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="Interest"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data?.interest
                                ? data?.accountMetrics?.calculated_data?.interest?.toFixed(
                                    2
                                  )
                                : 0
                            }
                          />
                        </div>
                      </Grid>

                      <Grid className="mtt-20 StatsTime" alignItems={"center"}>
                        <HeadAndDesc
                          width="100%"
                          HeadTitle="Timezone :"
                          SubTitle={String(new Date())?.split(" ")[5]}
                          HeadAndSubClassName="Timezone"
                        />
                        <HeadAndDesc
                          width="100%"
                          HeadTitle="Last Updated :"
                          SubTitle={currentTime}
                          HeadAndSubClassName="d-flex lastUpdated"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  className="CalDetailTradingBOx TradingObjBox d-grid mbb-20"
                >
                  <h5 className="title_section">Trading Objective</h5>
                  <Grid
                    className="TOBox mtt-20"
                    gap="10px"
                    display="flex"
                    flexDirection="column"
                  >
                    {data?.accountDetails &&
                    data?.accountDetails.status === "Funded" ? (
                      <AMDropdown
                        head={`Withdrawal Dates`}
                        desc={"Withdrawal dates"}
                        result={false}
                        status={
                          data?.accountObjectives &&
                          data?.accountObjectives["payout_dates"] &&
                          `${data?.accountObjectives.payout_dates[0]} & ${data?.accountObjectives.payout_dates[1]}`
                        }
                      />
                    ) : data?.accountObjectives ? (
                      <AMDropdown
                        head={`Minimum days - ${
                          data?.accountObjectives &&
                          data?.accountObjectives["trading_days"]
                            ? data?.accountObjectives["trading_days"]["target"]
                            : ""
                        }`}
                        desc={"Minimum trading days"}
                        result={
                          data?.accountObjectives &&
                          data?.accountObjectives["trading_days"]
                            ? data?.accountObjectives["trading_days"]["result"]
                            : ""
                        }
                        status={
                          data?.accountObjectives &&
                          data?.accountObjectives["trading_days"]
                            ? data?.accountObjectives["trading_days"]["status"]
                            : ""
                        }
                      />
                    ) : (
                      false
                    )}
                    {/* <ProfitTargetObj /> */}
                    {data?.accountObjectives ? (
                      <React.Fragment>
                        <AMDropdown
                          head={`Max Loss ${
                            data?.accountObjectives &&
                            data?.accountObjectives["drawdown_result"] &&
                            dollarUS(
                              data?.accountObjectives["drawdown_result"][
                                "max_loss"
                              ]["target"]
                            )
                          }`}
                          desc={"Max Loss"}
                          result={
                            data?.accountObjectives &&
                            data?.accountObjectives["drawdown_result"] &&
                            dollarUS(
                              data?.accountObjectives["drawdown_result"][
                                "max_loss"
                              ]["result"].toFixed(2)
                            )
                          }
                          status={
                            data?.accountObjectives &&
                            data?.accountObjectives["drawdown_result"] &&
                            data?.accountObjectives["drawdown_result"][
                              "max_loss"
                            ]["status"]
                          }
                        />
                        <AMDropdown
                          targetValue={
                            data?.accountObjectives &&
                            data?.accountObjectives["drawdown_result"] &&
                            dollarUS(
                              data?.accountObjectives["drawdown_result"][
                                "max_daily_loss"
                              ]["target"]
                            )
                          }
                          head={`Max Daily Loss ${
                            data?.accountObjectives &&
                            data?.accountObjectives["drawdown_result"] &&
                            dollarUS(
                              data?.accountObjectives["drawdown_result"][
                                "max_daily_loss"
                              ]["target"]
                            )
                          }`}
                          desc={"Max Daily Loss"}
                          result={
                            data?.accountObjectives &&
                            data?.accountObjectives["drawdown_result"] &&
                            dollarUS(
                              data?.accountObjectives["drawdown_result"][
                                "max_daily_loss"
                              ]["result"].toFixed(2)
                            )
                          }
                          status={
                            data?.accountObjectives &&
                            data?.accountObjectives["drawdown_result"][
                              "max_daily_loss"
                            ]["status"]
                          }
                          remaining={
                            data?.accountObjectives &&
                            String(
                              data?.accountObjectives["drawdown_result"][
                                "max_daily_loss"
                              ]["status"]
                            ).toLowerCase() === "failed"
                              ? false
                              : Number(
                                  data?.accountObjectives["drawdown_result"][
                                    "max_daily_loss"
                                  ]["remaining"]
                                ).toFixed(2)
                          }
                          targetDate={targetDate}
                        />
                      </React.Fragment>
                    ) : (
                      false
                    )}
                  </Grid>
                </Grid>
              </div>
            </div>
          ) : (
            <>
              {" "}
              <Grid
                container
                className="AMStatsBox mbb-20 AMStatsBoxContainer"
                justifyContent={"space-between"}
                gap={"20px"}
                marginTop={{ xs: "-30px" }}
                xs={12}
              >
                {" "}
                {/* <Grid
                  item
                  className="statsContainer"
                  textAlign="center"
                  md={true}
                  xs={true}
                >
                  <div className="StatsHead mbb-10">Email ID</div>
                  <div className="StatsSub">
                    {data?.accountDetails &&
                      (data?.accountDetails.email || "NA")}
                  </div>
                </Grid> */}
                <Grid
                  item
                  className="statsContainer"
                  textAlign="center"
                  md={true}
                  xs={true}
                >
                  <div className="StatsHead mbb-10">Login ID</div>
                  <div className="StatsSub">
                    {data?.accountDetails?.login_id &&
                      data?.accountDetails?.login_id}
                  </div>
                </Grid>
                <Grid
                  item
                  className="statsContainer"
                  textAlign="center"
                  md={true}
                  xs={true}
                >
                  <div className="StatsHead mbb-10">Start Date</div>
                  <div className="StatsSub">
                    {data?.accountDetails &&
                      formatDate(data?.accountDetails?.start_date)}
                  </div>
                </Grid>
                <Grid
                  item
                  className="statsContainer"
                  textAlign="center"
                  md={true}
                  xs={true}
                >
                  <div className="StatsHead mbb-10">Account Size</div>
                  <div className="StatsSub">
                    {data?.accountDetails &&
                    data?.accountDetails.challenge &&
                    data?.accountDetails.challenge.account_balance
                      ? dollarUS(data?.accountDetails.challenge.account_balance)
                      : 0}
                  </div>
                </Grid>
                <Grid
                  item
                  className="statsContainer"
                  textAlign="center"
                  md={true}
                  xs={true}
                >
                  <div className="StatsHead mbb-10">Status</div>
                  <div className="StatsSub statusBox">
                    {StatFormatter(
                      data?.accountDetails && data?.accountDetails.progress
                    )}
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="ProgramObjBox">
                <Grid item md={7} xs={12} className=" tradingObjectiveSection">
                  <div className="chartContainer">
                    <div className="charts_header">
                      <h3>Trading Objectives</h3>
                      {value === "1" && (
                        <div className="date_selector">
                          <DatePicker
                            className="date_picker_div"
                            selectsRange
                            startDate={startDate}
                            maxDate={new Date()}
                            endDate={endDate}
                            onChange={(update) => setDateRange(update)}
                            isClearable={true}
                            dateFormat="yyyy-MM-dd"
                            value={`${formatDate(startDate)} - ${formatDate(
                              endDate
                            )}`}
                          />
                        </div>
                      )}
                    </div>

                    <Box
                      className="ContainerTab"
                      md={12}
                      sx={{ width: "100%", height: "360px" }}
                    >
                      <TabContext value={value}>
                        <Box
                          className="SubTab"
                          sx={{ borderBottom: 1, borderColor: "divider" }}
                        >
                          <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                          >
                            <Tab
                              className="ContainertabName"
                              label="Balance"
                              value="1"
                            />
                            <Tab
                              className="ContainertabName"
                              label="Profit"
                              value="2"
                            />
                          </TabList>
                          {value === "1" && (
                            <div className="chart-legend">
                              {legendData.map((item, index) => (
                                <div className="legend" key={index}>
                                  <div>
                                    <span
                                      style={{ background: item.color }}
                                      className="circle"
                                    ></span>
                                    <p className="title">{item.title}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </Box>

                        <TabPanel className="ContainerTabpanel" value="1">
                          <BalanceChart
                            balance_chart={filteredData}
                            profit={
                              Number(
                                data?.accountObjectives?.profit_target?.target
                              ) +
                              Number(
                                data?.accountDetails?.challenge?.account_balance
                              )
                            }
                            maxLoss={
                              Number(
                                data?.accountDetails?.challenge
                                  ?.account_balance || 0
                              ) -
                              Number(
                                data?.accountObjectives?.drawdown_result
                                  ?.max_loss?.target > 0
                                  ? data?.accountObjectives?.drawdown_result
                                      ?.max_loss?.target
                                  : data?.accountObjectives?.drawdown_result
                                      ?.mll?.target || 0
                              )
                            }
                            accountType={
                              data?.accountObjectives?.drawdown_result
                                ?.account_type
                            }
                            maxDailyLoss={
                              Number(
                                data?.accountDetails?.challenge
                                  ?.account_balance || 0
                              ) -
                              Number(
                                data?.accountObjectives?.drawdown_result
                                  ?.max_daily_loss?.target
                              )
                            }
                          />
                        </TabPanel>
                        <TabPanel className="ContainerTabpanel" value="2">
                          <ProfitChart
                            data={ProfitHistory && ProfitHistory}
                            ProfitChartData={ProfitData}
                            ProfitData={ProfitData}
                          />
                        </TabPanel>
                      </TabContext>
                    </Box>
                  </div>
                  <Grid container className="TradingObjBox d-grid mbb-20">
                    <Title StyleName="title_section" six>
                      Trading Objective
                    </Title>
                    <Grid
                      className="TOBox mtt-20"
                      gap="10px"
                      display="flex"
                      flexDirection="column"
                    >
                      {/* Profit Target */}
                      {data?.accountObjectives?.profit_target?.target > 0 && (
                        <AMDropdown
                          head="Profit"
                          desc="Profit"
                          result={
                            data?.accountObjectives.profit_target.result?.toFixed(
                              2
                            ) || ""
                          }
                          status={
                            data?.accountObjectives.profit_target.status || ""
                          }
                          targetValue={dollarUS(
                            data?.accountObjectives.profit_target.target || 0
                          )}
                          remaining={
                            String(
                              data?.accountObjectives.profit_target.status || ""
                            ).toLowerCase() === "failed"
                              ? false
                              : (
                                  Number(
                                    data?.accountObjectives.profit_target
                                      .target || 0
                                  ) -
                                  Number(
                                    data?.accountObjectives.profit_target
                                      .result || 0
                                  )
                                ).toFixed(2)
                          }
                        />
                      )}

                      {/* Withdrawal Dates or Minimum Days */}
                      {(data?.accountDetails?.status === "Funded" && data?.accountObjectives?.payout_dates)? (
                        <>
                          { data?.accountObjectives.payout_dates[0]&&(
                            <AMDropdown
                              head="Withdrawal Dates"
                              desc="Withdrawal dates"
                              result={false}
                              status={
                                data?.accountObjectives?.payout_dates
                                  ? `${
                                      data?.accountObjectives.payout_dates[0] ||
                                      ""
                                    }${
                                      data?.accountObjectives
                                        .payout_dates[1] !== undefined
                                        ? " & " +
                                          data?.accountObjectives
                                            .payout_dates[1]
                                        : ""
                                    }`
                                  : ""
                              }
                            />
                          )}
                        </>
                      ) : (
                        data?.accountObjectives?.trading_days?.target > 0 &&
                        data?.accountDetails?.status !== "Funded" && (
                          <AMDropdown
                            head={`Minimum days - ${
                              data?.accountObjectives.trading_days.target || ""
                            }`}
                            desc="Minimum trading days"
                            result={
                              data?.accountObjectives.trading_days.result || ""
                            }
                            status={
                              data?.accountObjectives.trading_days.status || ""
                            }
                          />
                        )
                      )}

                      {/* Drawdown data?.accountObjectives */}
                      {data?.accountObjectives?.drawdown_result && (
                        <>
                          {data?.accountObjectives?.drawdown_result?.max_loss
                            ?.target > 0 && (
                            <AMDropdown
                              head={`Max Loss ${dollarUS(
                                data?.accountObjectives.drawdown_result.max_loss
                                  ?.target || 0
                              )}`}
                              desc="Max Loss"
                              result={dollarUS(
                                data?.accountObjectives.drawdown_result.max_loss?.result?.toFixed(
                                  2
                                ) || 0
                              )}
                              status={
                                data?.accountObjectives.drawdown_result.max_loss
                                  ?.status || ""
                              }
                            />
                          )}
                          {data?.accountObjectives?.drawdown_result
                            ?.max_daily_loss?.target > 0 && (
                            <AMDropdown
                              head={`Max Daily Loss ${dollarUS(
                                data?.accountObjectives.drawdown_result
                                  .max_daily_loss?.target || 0
                              )}`}
                              desc="Max Daily Loss"
                              result={dollarUS(
                                data?.accountObjectives.drawdown_result.max_daily_loss?.result?.toFixed(
                                  2
                                ) || 0
                              )}
                              status={
                                data?.accountObjectives.drawdown_result
                                  .max_daily_loss?.status || ""
                              }
                              targetValue={dollarUS(
                                data?.accountObjectives.drawdown_result
                                  .max_daily_loss?.target || 0
                              )}
                              remaining={
                                String(
                                  data?.accountObjectives.drawdown_result
                                    .max_daily_loss?.status || ""
                                ).toLowerCase() === "failed"
                                  ? false
                                  : Number(
                                      data?.accountObjectives.drawdown_result
                                        .max_daily_loss?.remaining || 0
                                    ).toFixed(2)
                              }
                              targetDate={targetDate}
                            />
                          )}
                        </>
                      )}

                      {data?.accountObjectives?.drawdown_result?.mll?.target >
                        0 && (
                        <AMDropdown
                          head={`Max loss limit - ${
                            (data?.accountObjectives.drawdown_result?.mll
                              ?.target &&
                              dollarUS(
                                data?.accountObjectives.drawdown_result?.mll
                                  ?.target
                              )) ||
                            ""
                          }`}
                          desc="MLL"
                          result={
                            (data?.accountObjectives.drawdown_result?.mll
                              .result &&
                              dollarUS(
                                data?.accountObjectives.drawdown_result?.mll
                                  .result
                              )) ||
                            "0"
                          }
                          status={
                            data?.accountObjectives.drawdown_result?.mll
                              .status || ""
                          }
                        />
                      )}

                      {data?.accountObjectives?.consistency?.target > 0 &&
                        data?.accountObjectives.consistency.result > 0 &&
                        (
                          <AMDropdown
                            head={`Consistency - ${
                              data?.accountObjectives.consistency?.target || ""
                            }`}
                            desc="Consistency"
                            result={
                              data?.accountObjectives.consistency.result || "0"
                            }
                            status={
                              data?.accountObjectives.consistency.status || ""
                            }
                          />
                        )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={5} xs={12} className="statisticsSection">
                  {" "}
                  <Grid container className="StatisticsBox d-grid mbb-20">
                    {/* <Title six>Statistic</Title> */}
                    <div>
                      <Grid className="mtt-20 AMStatBox inner_Box">
                        <Grid
                          item
                          className="StatisticAM  mbb-20"
                          xs={6}
                          justifyContent="space-between"
                        >
                          <HeadAndDesc
                            className="hover-chart-text"
                            HeadTitle="Equity"
                            SubTitle={
                              data?.accountDetails &&
                              data?.accountDetails.equity
                                ? dollarUS(data?.accountDetails.equity)
                                : "$0"
                            }
                          />
                          <HeadAndDesc
                            className="hover-chart-text"
                            HeadTitle="Balance"
                            SubTitle={
                              data?.accountDetails &&
                              data?.accountDetails.balance
                                ? dollarUS(data?.accountDetails.balance)
                                : "$0"
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="No. of trades"
                            SubTitle={
                              (data?.accountMetrics?.calculated_data &&
                                data?.accountMetrics?.calculated_data.trades) ||
                              0
                            }
                          />{" "}
                          <HeadAndDesc
                            HeadTitle="Lots"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data.lots
                                ? data?.accountMetrics?.calculated_data.lots.toFixed(
                                    2
                                  )
                                : 0
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="Win rate"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data.win_ratio
                                ? `${data?.accountMetrics?.calculated_data.win_ratio.toFixed(
                                    2
                                  )} %`
                                : "0 %"
                            }
                          />
                          <HeadAndDesc HeadTitle="Highest" SubTitle={"NA"} />
                        </Grid>
                        <Grid
                          item
                          className="StatisticAM  gapp-10 mbb-20"
                          xs={6}
                          justifyContent="space-between"
                        >
                          {" "}
                          <HeadAndDesc
                            HeadTitle="Average profit"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data
                                .average_profit
                                ? dollarUS(
                                    Number(
                                      data?.accountMetrics?.calculated_data
                                        .average_profit
                                    ).toFixed(2)
                                  )
                                : "$0"
                            }
                            SubTitleClass="DescPositive"
                          />
                          <HeadAndDesc
                            HeadTitle="Average loss"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data.average_loss
                                ? dollarUS(
                                    Number(
                                      data?.accountMetrics?.calculated_data
                                        .average_loss
                                    ).toFixed(2)
                                  )
                                : "$0"
                            }
                            SubTitleClass="DescNegative"
                          />
                          <HeadAndDesc
                            HeadTitle="Average RRR"
                            SubTitle={
                              data?.accountMetrics?.calculated_data &&
                              data?.accountMetrics?.calculated_data["rrr "]
                                ? Number(
                                    data?.accountMetrics?.calculated_data[
                                      "rrr "
                                    ]
                                  ).toFixed(2)
                                : 0
                            }
                          />
                          <HeadAndDesc HeadTitle="Expectancy" SubTitle={"NA"} />
                          <HeadAndDesc
                            HeadTitle="Profit factor"
                            SubTitle={"NA"}
                          />
                          <HeadAndDesc HeadTitle="Interest" SubTitle={"NA"} />
                        </Grid>
                        <Grid
                          item
                          className="StatisticAM  gapp-10 mbb-20"
                          xs={6}
                          justifyContent="space-between"
                          mt={2.5}
                        >
                          <HeadAndDesc
                            HeadTitle="Rollover Equity"
                            SubTitle={dollarUS(
                              data?.accountObjectives?.drawdown_result?.eod_data
                                ?.equity
                            )}
                          />
                          <HeadAndDesc
                            HeadTitle="Rollover Balance"
                            SubTitle={dollarUS(
                              data?.accountObjectives?.drawdown_result?.eod_data
                                ?.balance
                            )}
                          />
                          <HeadAndDesc
                            HeadTitle="Breached at"
                            SubTitle={
                              breachedAtObject?.time ? (
                                <>
                                  <div>
                                    {moment(breachedAtObject?.time).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </div>

                                  <div>
                                    {moment(breachedAtObject?.time).format(
                                      "hh:mm:ss"
                                    )}
                                  </div>
                                </>
                              ) : (
                                "NA"
                              )
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="Breached balance"
                            SubTitle={
                              (breachedAtObject?.balance &&
                                dollarUS(breachedAtObject?.balance)) ||
                              "NA"
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="Breached equity"
                            SubTitle={
                              (breachedAtObject?.equity &&
                                dollarUS(breachedAtObject?.equity)) ||
                              "NA"
                            }
                          />
                          <HeadAndDesc
                            HeadTitle="End Date"
                            SubTitle={
                              data?.accountDetails &&
                              Object.keys(data?.accountDetails).length &&
                              data?.accountDetails.expiry_date
                                ? formatDate(data?.accountDetails.expiry_date)
                                : "Ongoing"
                            }
                          />
                        </Grid>
                        <Grid
                          className="mtt-20 StatsTime"
                          alignItems={"center"}
                        >
                          <HeadAndDesc
                            width="100%"
                            HeadTitle="Timezone :"
                            SubTitle={String(new Date()).split(" ")[5]}
                            HeadAndSubClassName="Timezone"
                          />
                          <HeadAndDesc
                            width="100%"
                            HeadTitle="Last Updated :"
                            SubTitle={String(new Date()).split("GMT")[0].trim()}
                            HeadAndSubClassName="d-flex lastUpdated"
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </div>

        <div className="main_calendar_container" style={{ marginTop: "24px" }}>
          <NewCalender
            data={data?.accountMetrics?.data || []}
            setSelectedDateValue={setSelectedDateValue}
            selectedDateValue={selectedDateValue}
            setDateWiseData={setDateWiseData}
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
          />
        </div>
      </div>
    </div>
  );
};

export default PublicShareDashboard;
